/**
 * Representing authenticated user model.
 */
class AuthenticatedUser
{
    /**
     * Instanciating user instance based on auth user response.
     * @param {import("../types").AuthenticatedUserResponseUserInterface} user
     */
    constructor(user)
    {
        // Defined manually to get nice intellisense.
        this.id = user.id;
        this.locale = user.locale;
        this.id = user.id;
        this.intercom_hash = user.intercom_hash;
        this.first_name = user.first_name;
        this.last_name = user.last_name;
        this.email = user.email;
        this.created_at = user.created_at;
        this.jwt = user.jwt;
        // Only this line was actually needed.
        Object.entries(user).forEach(([key, value]) => this[key] = value);
    }
    
    /** 
     * Firstname + Last name first character.
     * @returns {string}
     */
    getShortName()
    {
        return `${this.first_name} ${this.last_name.charAt(0)}`;
    }
    
    /**
     * Firstname + last name.
     * @returns {string}
    */
    getFullName()
    {
        return `${this.first_name} ${this.last_name}`;
    }
    
    /**
     * Telling if given user can be considered as this user.
     * @param {User} user
     * @returns {boolean}
     */
    is(user)
    {
        return user.id === this.id;
    }
}

export default AuthenticatedUser;